import { t } from "i18next";
import moment from "moment";
import React from "react";
import { Driver } from "src/utils/interfaces/interfaces";

type IDriverProps = { Driver: Driver };

export default function DriverCard({ Driver }: IDriverProps) {
  return (
    <div className="rounded-lg bg-white/[0.04] px-6">
      <div className="py-4 text-center border-b border-primary">
        <div className="bg-black-200/[0.7] rounded-full w-fit mx-auto px-4 py-2 mb-1.5">
          <p className="pt-1 text-3xl font-bold text-center place-self-center">
            D
          </p>
        </div>
        <p className="text-lg font-semibold capitalize">{`${Driver?.firstName || ""} ${Driver?.lastName || ""
          }`}</p>
      </div>
      <div className="grid grid-cols-6 py-4 border-b border-primary">
        <img
          src="/assets/icons/shipper/phone.svg"
          alt="phone"
          className="my-auto"
        />
        <div className="col-span-5">
          <p className="text-blue/[0.5] text-sm">
            {t("user.contact_number")}
          </p>
          <p>{Driver?.phone || <span className="opacity-50">N/A</span>}</p>
        </div>
      </div>
      <div className="grid grid-cols-6 py-4 border-b border-primary">
        <img
          src="/assets/icons/shipper/dl.svg"
          alt="driver license"
          className="my-auto"
        />
        <div className="col-span-5">
          <p className="text-blue/[0.5] text-sm">
            {t("driver.dl_no")}
          </p>
          <p>{Driver?.dlNumber || <span className="opacity-20">N/A</span>}</p>
        </div>
      </div>
      <div className="grid grid-cols-6 py-4 border-b border-primary">
        <img
          src="/assets/icons/shipper/calendar.svg"
          alt="license expiry"
          className="my-auto"
        />
        <div className="col-span-5">
          <p className="text-blue/[0.5] text-sm">
            {t("driver.license_expiry")}
          </p>
          <p>
            {Driver?.dlExpiry
              ? moment(Driver?.dlExpiry).format("Do MMM YYYY, h:mm a")
              : <span className="opacity-20">N/A</span>}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-6 py-4 border-b border-primary">
        <img
          src="/assets/icons/shipper/calendar.svg"
          alt="nationality"
          className="my-auto"
        />
        <div className="col-span-5">
          <p className="text-blue/[0.5] text-sm">
            {t("user.nationality")}
          </p>
          <p className="text-sm">
            {Driver?.nationality || <span className="opacity-20">N/A</span>}
          </p>
        </div>
      </div>
    </div>
  );
}
